/* eslint-disable array-callback-return */
import React from 'react';
import { LidarLayer } from './LidarLayer';
import { ModelSetLayer } from './ModelSetLayer';
import { Acute3DLayer } from './Acute3DLayer';
import { VisualizedDataGridOverlay } from './VisualizedDataGridOverlay';
import { VisualizedDataGridOverlay_DataCube } from './VisualizedDataGridOverlay_DataCube';
import { MoveModelLayer } from './MoveModelLayer';
import { PipelineLayer } from './PipelineLayer';
import { ModelLayer } from './ModelLayer';
import { ProjectorLayer } from './ProjectorLayer';
import { I3SLayer } from './I3SLayer';
import { ThreeDTilesLayer } from './3DTilesLayer';
import { CustomLayer } from './CustomLayer';

class Layer3DGroup extends React.Component{
    constructor(){
        super();
        this.state = {
            List: [],
            URL: window.TERRAIN_SERVER.URL,
            URLTemplate: window.TERRAIN_SERVER.URLTemplate,
            Token: ""
        };
    }
    componentDidMount(){
        this.setState({
            List: this.props.List,
            URL: this.props.URL,
            URLTemplate: this.props.URLTemplate,
            Token: this.props.Token
        });
    }
    render(){
        const List = this.state.List;
        const URL = this.state.URL;
        const URLTemplate = this.state.URLTemplate;
        const Token = this.state.Token;
        const deleteList = this.props.deleteList;
        return( 
            <div className="ts checkboxes">
                {
                    List.map(
                        (layer,index)=>
                        {
                            switch(layer.TYPE){
                                case "Lidar" :
                                    return <LidarLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "ModelSet":
                                    return <ModelSetLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList} setinfoBox={(attr)=>this.props.setinfoBox(attr)} setinfoBoxOpen = {this.props.setinfoBoxOpen} setLegendBoxSwitch={this.props.setLegendBoxSwitch} setLegendBoxContent={this.props.setLegendBoxContent} setTimeLineContent = {this.props.setTimeLineContent} currentTime={this.props.currentTime}/>;
                                case "Acute3D":
                                    return <Acute3DLayer layer={layer} setOpenLayer={(layer, layerHandel) => this.props.setOpenLayer(layer, layerHandel)} deleteLayer={(layer) => this.props.deleteLayer(layer)} deleteList={deleteList} URL={URL} URLTemplate={URLTemplate} Token={Token} />;
                                case "VisualizedDataGrid":
                                    return <VisualizedDataGridOverlay layer={layer} setOpenLayer={(layer, layerHandel) => this.props.setOpenLayer(layer, layerHandel)} deleteLayer={(layer) => this.props.deleteLayer(layer)} deleteList={deleteList} />;
                                case "VisualizedDataGrid_DataCube":
                                    return <VisualizedDataGridOverlay_DataCube layer={layer} setOpenLayer={(layer, layerHandel) => this.props.setOpenLayer(layer, layerHandel)} deleteLayer={(layer) => this.props.deleteLayer(layer)} deleteList={deleteList} />;
                                case "MoveModel":
                                    return <MoveModelLayer layer={layer} setOpenLayer={(layer, layerHandel) => this.props.setOpenLayer(layer, layerHandel)} deleteLayer={(layer) => this.props.deleteLayer(layer)} deleteList={deleteList} />;
                                case "Pipeline":
                                    return <PipelineLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "Model":
                                    return <ModelLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "Projector":
                                    return <ProjectorLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "I3S":
                                    return <I3SLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "3DTiles":
                                    return <ThreeDTilesLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "Custom":
                                    return <CustomLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList} setinfoBox={(attr)=>this.props.setinfoBox(attr)} setLegendBoxSwitch={this.props.setLegendBoxSwitch} setLegendBoxContent={this.props.setLegendBoxContent} setTimeLineContent = {this.props.setTimeLineContent} currentTime={this.props.currentTime}/>;

                                default:
                                    break;
                            }
                        }
                    )
                }
            </div>           
        );
    }
}

export default Layer3DGroup;